/**
 * Planned process step of a production order (spec 0040 §2.3).
 * Subcollection: org/{orgId}/production-order/{productionOrderId}/step
 *
 * No lifecycle. Materialized on `draft → released` from the resolved technical
 * sheet (0169); empty when the OP has no sheet (D7). Resolve the repository
 * with context `{ orgId, productionOrderId }`.
 */
export const PRODUCTION_ORDER_STEP = 'ProductionOrderStep';
export const ProductionOrderLineSourceValues = [
    'sheet',
    'manual',
];
export const PRODUCTION_ORDER_LINE_SOURCE_LABELS = {
    sheet: 'Ficha',
    manual: 'Manual',
};
//# sourceMappingURL=production-order-step.js.map